"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class ActivityService {
    async createRecruitmentParticipant(data) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/activity/participant/create/recruitment`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).fetch();
        }
        catch (err) {
            throw new Error(`Failed to create the participants recruited in the session: status ${err.message}`);
        }
    }
    async createActivityParticipant(data) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/activity/participant/create/academy`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).fetch();
        }
        catch (err) {
            throw new Error(`Failed to create the academy participants: status ${err.message}`);
        }
    }
    async getAvailableClassRoom() {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/activity/academy/session/get`).fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get carousel banners: status ${err.message}`);
        }
    }
    async getClassRoomDetail(academySessionClassRoom) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/activity/academy/classroom/detail?academySessionClassRoom=${academySessionClassRoom}`).fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get carousel banners: status ${err.message}`);
        }
    }
}
exports.default = ActivityService;
//# sourceMappingURL=ActivityService.js.map